module.exports = __webpack_public_path__ + "img/김가영1.c3e72616.jpeg";